export const LogLevel = [
  { name: '0', description: 'modules.expert-tool.log-level-0' },
  { name: '2', description: 'modules.expert-tool.log-level-2' },
];
